
import { Icon } from '@chakra-ui/react';
export const NetchexMinus = (props) => (
  <Icon viewBox="0 0 12 13" boxSize="16px" color="icon.g1" {...props}>
<path d="M12 6.50005C12 6.87505 11.6827 7.19235 11.3077 7.19235H0.692308C0.317308 7.19235 0 6.87505 0 6.50005C0 6.12505 0.317308 5.80774 0.692308 5.80774H11.3077C11.6827 5.80774 12 6.12505 12 6.50005Z" fill="#757575"/>
</Icon>
  );
